module.exports = __webpack_public_path__ + "assets/img/bilibili-17f997aa.png";